define(['exports', 'lodash', 'react', 'prop-types', '../../i18n', '../../assets/visibility-on.svg', '../../assets/visibility-off.svg', '../common/Field', '../common/Button', '../common/Errors'], function (exports, _lodash, _react, _propTypes, _i18n, _visibilityOn, _visibilityOff, _Field, _Button, _Errors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _lodash2 = _interopRequireDefault(_lodash);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _i18n2 = _interopRequireDefault(_i18n);

  var _visibilityOn2 = _interopRequireDefault(_visibilityOn);

  var _visibilityOff2 = _interopRequireDefault(_visibilityOff);

  var _Field2 = _interopRequireDefault(_Field);

  var _Button2 = _interopRequireDefault(_Button);

  var _Errors2 = _interopRequireDefault(_Errors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var visibilityIconStyle = {
    'cursor': 'pointer',
    'paddingTop': '1.45rem',
    'width': '0.133%',
    'right': '0.45rem'
  };

  var LoginForm = function (_Component) {
    _inherits(LoginForm, _Component);

    function LoginForm(props) {
      _classCallCheck(this, LoginForm);

      var _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this, props));

      _this.state = {
        showErrors: false,
        passwordVisibility: false
      };
      props.updatePassword(props.login.password);
      return _this;
    }

    _createClass(LoginForm, [{
      key: 'handleLogin',
      value: function handleLogin() {
        var _props = this.props,
            errors = _props.login.errors,
            loginUser = _props.loginUser;

        this.setState({ showErrors: true });
        !(errors && errors.validation) && loginUser();
      }
    }, {
      key: 'renderErrors',
      value: function renderErrors() {
        var errors = this.props.login.errors;

        return _react2.default.createElement(_Errors2.default, { errors: [errors.login] });
      }
    }, {
      key: 'handleEnter',
      value: function handleEnter() {
        this.handleLogin();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props2 = this.props,
            login = _props2.login,
            history = _props2.history,
            routePath = _props2.routePath,
            updatePassword = _props2.updatePassword,
            updateEmail = _props2.updateEmail;
        var email = login.email,
            password = login.password,
            errors = login.errors;

        var emailError = errors.validation && errors.validation.email ? _i18n2.default.t('dk-ui-lib.errors.login.email') : '';
        var passwordError = errors.validation && errors.validation.password ? _i18n2.default.t('dk-ui-lib.errors.login.password') : '';
        var _state = this.state,
            showErrors = _state.showErrors,
            passwordVisibility = _state.passwordVisibility;

        return _react2.default.createElement(
          'div',
          { level: 1, className: 'card p4 mx2 h5 white-background' },
          _react2.default.createElement(
            'div',
            { className: 'mb3' },
            errors.login && this.renderErrors()
          ),
          _react2.default.createElement(
            'div',
            { className: 'mb3' },
            _react2.default.createElement(_Field2.default, {
              label: _i18n2.default.t('dk-ui-lib.login.email')
              // placeholder={'aaa@aa.com'}
              , inputType: 'text',
              value: email,
              shouldHideValidationIcon: true,
              errorPosition: 'bottom',
              onChange: updateEmail, onEnter: function onEnter() {
                return _this2.handleEnter();
              },
              msgs: { error: showErrors && emailError } })
          ),
          _react2.default.createElement(
            'div',
            { className: 'mb2 flex clearfix' },
            _react2.default.createElement(
              'div',
              { className: 'z1 flex-auto' },
              _react2.default.createElement(_Field2.default, { label: _i18n2.default.t('dk-ui-lib.login.password'),
                inputType: passwordVisibility ? 'text' : 'password'
                // placeholder={'.....'}
                , value: password,
                shouldHideValidationIcon: true,
                errorPosition: 'bottom',
                onChange: updatePassword,
                onEnter: function onEnter() {
                  return _this2.handleEnter();
                },
                msgs: { error: showErrors && passwordError } })
            ),
            _react2.default.createElement(
              'div',
              {
                style: visibilityIconStyle,
                className: 'relative z2',
                onClick: function onClick() {
                  return _this2.setState({ passwordVisibility: !passwordVisibility });
                } },
              passwordVisibility ? _react2.default.createElement(_visibilityOn2.default, { className: 'svg-icon svg-1x svg-grey' }) : _react2.default.createElement(_visibilityOff2.default, { className: 'svg-icon svg-1x svg-grey' })
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: 'secondary mb2 clickable',
                onClick: function onClick() {
                  return history.push(routePath.forgetPasswordRoute);
                }
              },
              _i18n2.default.t('dk-ui-lib.login.forgotPassword')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'flex items-center flex-column mt3' },
            _react2.default.createElement(_Button2.default, {
              type: 'primary',
              buttonStyle: { padding: '0.7rem' },
              label: _i18n2.default.t('dk-ui-lib.login.login'),
              labelStyle: { fontSize: '1rem' },
              onClick: function onClick() {
                return _this2.handleLogin();
              } })
          )
        );
      }
    }]);

    return LoginForm;
  }(_react.Component);

  LoginForm.propTypes = {
    login: _propTypes2.default.object.isRequired,
    loginUser: _propTypes2.default.func.isRequired,
    updateEmail: _propTypes2.default.func.isRequired,
    updatePassword: _propTypes2.default.func.isRequired
  };

  exports.default = LoginForm;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/login/LoginForm.js
// module id = 1174
// module chunks = 0